import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRefreshTimerComponent } from './dashboard-refresh-timer/dashboard-refresh-timer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DashboardRefreshTimerComponent],
  exports: [DashboardRefreshTimerComponent]
})
export class DashboardRefreshTimerModule { }
